module.exports = __webpack_public_path__ + "media/components/images/logo_white-f99f4ced9b07b9e8cda325569b33d269.png";